var _defs, _path, _rect, _rect2, _circle, _path2, _circle2, _line, _path3, _circle3, _line2, _path4, _path5, _path6, _path7, _circle4, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _polyline, _circle5, _path14, _path15, _polyline2, _rect3, _path16, _path17, _path18, _polyline3, _rect4, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e1e6ea;}.cls-2{fill:#fff;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-3,.cls-5,.cls-6,.cls-7,.cls-8{fill:none;stroke-linecap:round;}.cls-3{stroke:#ffaa96;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-3,.cls-6,.cls-7,.cls-8{stroke-miterlimit:10;}.cls-11,.cls-3{stroke-width:1.18px;}.cls-4{fill:#f9f9f9;}.cls-5,.cls-6{stroke:#fff;stroke-width:1.73px;}.cls-5{stroke-linejoin:round;}.cls-10,.cls-7,.cls-8{stroke:#3c4650;}.cls-7{stroke-width:0.62px;}.cls-8{stroke-width:1.17px;}.cls-9{fill:#f05f2a;}.cls-10{stroke-width:0.63px;}.cls-11,.cls-12,.cls-13{stroke:#748699;}.cls-12{stroke-width:0.73px;}.cls-13{stroke-width:0.58px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graphic-account-lock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.36,134.41a5.83,5.83,0,0,0,5.84,5.82H355.79a5.83,5.83,0,0,0,5.84-5.82V39.28a5.83,5.83,0,0,0-5.84-5.82H193.2a5.83,5.83,0,0,0-5.84,5.82Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 51.27,
    y: 93.3,
    width: 101.48,
    height: 74.49
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 393.08,
    y: 88.98,
    width: 43.18,
    height: 72.33
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 102.49,
    cy: 129.31,
    r: 19.52
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.58,160.83V96.74a7.26,7.26,0,0,0-7.26-7.26H55.17a7.26,7.26,0,0,0-7.26,7.26v64.09a7.26,7.26,0,0,0,7.26,7.26h94.15A7.26,7.26,0,0,0,156.58,160.83ZM68.14,162a5.63,5.63,0,0,1-5.63-5.63v-55.2a5.63,5.63,0,0,1,5.63-5.63h68.21a5.63,5.63,0,0,1,5.63,5.63v55.2a5.63,5.63,0,0,1-5.63,5.63Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 56.21,
    cy: 129.46,
    r: 2.83
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 154.33,
    y1: 125.18,
    x2: 154.33,
    y2: 132.39
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M434.16,80.67H393.91A3.3,3.3,0,0,0,390.62,84V164.1a3.29,3.29,0,0,0,3.29,3.29h40.25a3.29,3.29,0,0,0,3.29-3.29V84A3.3,3.3,0,0,0,434.16,80.67Zm-2.48,72a2.78,2.78,0,0,1-2.78,2.78H397.46a2.78,2.78,0,0,1-2.78-2.78V97.28a2.78,2.78,0,0,1,2.78-2.78H428.9a2.78,2.78,0,0,1,2.78,2.78Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 413.48,
    cy: 161.19,
    r: 3.02
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 416.59,
    y1: 87.66,
    x2: 410.67,
    y2: 87.66
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M84,169.76h67.17a7.26,7.26,0,0,0,7.26-7.26V129.09m-9-38H57.07a7.26,7.26,0,0,0-7.26,7.26v64.09a7.26,7.26,0,0,0,7.26,7.26H67.64"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M389.56,145.08V166.3a3.29,3.29,0,0,0,3.29,3.29H433.1a3.29,3.29,0,0,0,3.29-3.29V86.17a3.29,3.29,0,0,0-3.29-3.29H392.85"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M392.85,82.88a3.29,3.29,0,0,0-3.29,3.29v13"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M88.82,110.93l0-2.45c0-2,0-3.7-3-3.67l-2.16,0c-2.95,0-2.93,1.83-2.9,3.73l0,2.45-1.85,0,.06,5.17c0,2.89.06,5.4,4.36,5.35l3.15,0c4.3,0,4.27-2.67,4.23-5.44l-.06-5.17Zm-5.32-3.37,2.51,0,0,3.43-2.51,0ZM86.1,115l-.36.79.4,2.54-2.51,0,.34-2.48-.38-.84s-.14-1.05,1.24-1.07S86.1,115,86.1,115Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 413.63,
    cy: 124.75,
    r: 13.58
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M194.36,131a5.37,5.37,0,0,0,5.41,5.33H350.44a5.37,5.37,0,0,0,5.41-5.33V43.79a5.37,5.37,0,0,0-5.41-5.33H199.78a5.37,5.37,0,0,0-5.41,5.34Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368.68,157.93c-1.87-2.13-4.08-4.83-5.25-6.19-2.45-3-4.24-4.29-8.34-4.29H191.75c-4.1,0-5.89,1.28-8.34,4.29-1.17,1.36-3.38,4.07-5.25,6.19s-1.77,4.56,4.2,4.56H364.48C370.45,162.48,370.55,160,368.68,157.93Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M186.47,68V38.41a5.87,5.87,0,0,1,5.87-5.87H355.76a5.87,5.87,0,0,1,5.87,5.87V98.3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M207.06,140.23H191.84a5.37,5.37,0,0,1-5.37-5.37V106.12"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M362.42,121.57v12.79a5.87,5.87,0,0,1-5.87,5.87H271.91"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M378.28,162.18c-2.55-2.9-5.59-6.61-7.18-8.46-3.36-4.12-5.8-5.87-11.41-5.87H187.6c-5.6,0-8.05,1.75-11.41,5.88-1.6,1.85-4.63,5.56-7.18,8.46s-2.41,6.24,5.75,6.24H372.53C380.7,168.42,380.83,165.09,378.28,162.18Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M261.9,86.17v2.3c0,.21,0,1.66-1.42,1.66h-1.6c-1.22,0-1.28-1.25-1.28-1.66v-2.3Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M296.46,80.35H252.87v9.12c0,1.54.23,6.19,4.79,6.19h3.18c5.3,0,5.32-5.43,5.32-6.19v-3.3h17.56V92.8h-5"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "296.46 86.17 289.51 86.17 289.51 92.8 294 92.8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 274.05,
    cy: 86.52,
    r: 35.03
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M96.37,129.36v1.12c0,.1,0,.81-.7.81h-.78c-.6,0-.63-.61-.63-.81v-1.12Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M113.25,126.51H92V131c0,.75.11,3,2.34,3h1.55c2.59,0,2.6-2.65,2.6-3v-1.61H107v3.24H104.6"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "113.25 129.36 109.86 129.36 109.86 132.6 112.05 132.6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 238.08,
    y: 60.84,
    width: 9.33,
    height: 12.24
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M249.17,57.77l-.05-4.25c0-3.45-.07-6.42-5.19-6.36l-3.75,0c-5.11.05-5.08,3.18-5,6.48l0,4.25L232,58l.1,9c.06,5,.11,9.37,7.57,9.28l5.47-.07c7.46-.08,7.41-4.63,7.35-9.45l-.1-9Zm-9.24-5.85,4.36,0,.07,5.95-4.36.05Zm4.51,12.88-.63,1.37.69,4.41-4.36,0,.6-4.31-.66-1.46S239.84,63,242.24,63,244.44,64.79,244.44,64.79Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M409.29,124.38v.79c0,.07,0,.57-.49.57h-.55c-.42,0-.44-.43-.44-.57v-.79Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M421.14,122.38H406.2v3.12c0,.53.08,2.12,1.64,2.12h1.09c1.82,0,1.82-1.86,1.82-2.12v-1.13h6v2.27h-1.7"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "421.14 124.38 418.75 124.38 418.75 126.65 420.29 126.65"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 398.4,
    y: 111.56,
    width: 6.41,
    height: 6.41
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M405.22,109.94l0-2.33c0-1.89,0-3.51-2.84-3.48l-2.05,0c-2.8,0-2.78,1.74-2.76,3.55l0,2.33-1.75,0,.06,4.91c0,2.75.06,5.13,4.14,5.08l3,0c4.08,0,4.05-2.53,4-5.17l-.06-4.91Zm-5.05-3.2,2.38,0,0,3.25-2.38,0Zm2.47,7-.34.75.38,2.41-2.38,0,.33-2.36-.36-.8s-.13-1,1.18-1S402.63,113.79,402.63,113.79Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountLock);
export default __webpack_public_path__ + "static/media/account-lock.f684a8bedd44adba887e7caffc999901.svg";
export { ForwardRef as ReactComponent };